import styled from "@emotion/styled";
import React from "react";
import {
    color_colors_ocean,
    color_shades_dark,
    color_shades_darkest,
    color_text_link,
    color_variants_main_bg,
    color_variants_ocean_light_opaque
} from "../../../constants/colors";

interface CountButtonProps {
    isActive?: boolean;
    onClick: (e?: any) => void;
    showCount?: boolean;
    count?: number;
    activeIcon?: string;
    inactiveIcon?: string;
    className?: string;
    text: string
}
export const CountButton = (props: CountButtonProps) => {
    const hasImage = props.activeIcon || props.inactiveIcon;
    return (
        <StyledButton
            type="button"
            className={`${props.isActive ? 'active' : 'inactive'} ${props.className ?? ''}`}
            onClick={(e) => { e.stopPropagation(); props.onClick(e); }}
        >
            <p>{props.text}</p>
            {props.showCount ?
                props.count > 0
                    ? <span className="count-number">{props.count}</span>
                    : hasImage ? <img src={props.isActive ? props.activeIcon : props.inactiveIcon} /> : <></>
                : hasImage ? <img src={props.isActive ? props.activeIcon : props.inactiveIcon} /> : <></>
            }
        </StyledButton>
    );
};

const StyledButton = styled.button`
        border-radius: 16px;
        border: 1px solid ${color_shades_dark};
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 16px;
        cursor: pointer;
        padding: 0 24px;
        background: ${color_variants_main_bg};
        font-family: 'Muli';
        .count-number {
            color: white;
            border-radius: 50%;
            width: 16px;
            height: 16px;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            margin-top: 3px;
            margin-left: 8px;
            background: ${color_shades_darkest};
            font-family: 'Muli';
        }
        img {
            margin-left: 8px;
        }
        &.active {
            background: ${color_variants_ocean_light_opaque};
            border-color: ${color_colors_ocean};
            color: ${color_text_link};
        }
`;